import initPrimaryNav from "../PrimaryNav/initPrimaryNav.js";
import initMobileMenu from "../MobileMenu/initMobileMenu.js";
import initSearchMenu from "../SearchMenu/initSearchMenu.js";

import uniqueid from "lodash.uniqueid";

export default () => {
  document
    .querySelectorAll(".js-global-header")
    .forEach((elGlobal, indexGlobal) => {
      // VRD-535 - Primary Nav and Quick Search have ID values that are being duplicated between desktop and mobile.
      // Solution is to remove one set of ID values before initialize the code.
      elGlobal.querySelectorAll(".js-primary-nav").forEach((el, i) => {
        if (i !== 0 && !window.ExperienceEditor) {
          el.querySelectorAll("[id]").forEach((el) => {
            el.removeAttribute("id");
          });
        }

        initPrimaryNav(el, i);
      });

      elGlobal.querySelectorAll(".js-mobile-menu").forEach(initMobileMenu);

      // duplicate ids on the two forms
      elGlobal
        .querySelectorAll(".js-search-menu")
        .forEach((searchEl, searchIndex) => {
          initSearchMenu(searchEl, searchIndex);
          const id = uniqueid("search-form-");
          searchEl.querySelector("label").setAttribute("for", id);
          searchEl.querySelector("input").setAttribute("id", id);
        });
    });
};
